export const CONSTS = {
  ADD: $localize`Add`,
  SECURE_FTP: $localize`Secure FTP`,
  HOST_NAME: $localize`Host Name`,
  HOST_NAME_PLACEHOLDER: $localize`Enter Host Name`,
  DIRECTORY: $localize`Directory`,
  DIRECTORY_PLACEHOLDER: $localize`Enter Directory`,
  USER_NAME: $localize`User Name`,
  USER_NAME_PLACEHOLDER: $localize`Enter User Name`,
  PASSWORD: $localize`Password`,
  PASSWORD_PLACEHOLDER: $localize`Enter Password`,
  PORT_NUMBER: $localize`Port Number`,
  PORT_NUMBER_PLACEHOLDER: $localize`Enter Port Num`,
};
